<template>
  <div v-if="loading">
    <oil-cap
        title="Счет фактуры"
        :buttons="[
        {
          route: 'coming-invoice',
          name: 'Добавить Счет фактуру'
        }
      ]"
        :items="invoices"
    />
    <v-divider class="my-2"/>
    <oil-table
        :keys="[
        {
          text: 'Поставщик',
          value: 'SupplierName'
        },
        {
          text: 'Договор',
          value: 'ContactNumber'
        },
        {
          text: 'Счет фактура',
          value: 'Number'
        },
        {
          text: 'Количество',
          value: 'Amount'
        },
        {
          text: 'Сумма',
          value: 'Total'
        },
        {
          text: 'Статус',
          value: 'Status'
        }
      ]"
        :items="invoices"
        :paginate='count'
        @paginateAction='paginate'
        :rowClick="handleRowClick"
    >
    </oil-table>
  </div>
</template>

<script>

import {coreApi} from "~/services/core";

export default {
  components: {
    OilTable: () => import('@/components/helper/oil.table.vue'),
    OilCap: () => import('@/components/helper/oil.cap'),
    OilModal: () => import('@/components/helper/form/oil.delete.modal'),
  },
  data: () => ({
    loading: false,
    invoices: [],
    status: {
      active: 'Активный',
      notsigned: 'Неподписанный',
      special: 'Особый',
      inactive: 'Неактивный'
    },
    count:{
      count:0
    }

  }),
  async created() {
    await this.paginate((this.currentPage - 1) * 10)
    this.loading = true
  },
  methods: {
    handleRowClick({Id}) {
      this.$router.push(`coming-invoice/${Id}`)
    },
    async paginate(page) {
      const invoices = await coreApi.get(`coming-invoice/${page}`)
      const { count, dates } = invoices.data
      this.count.count = count
      this.invoices = dates?.map(invoice => {
        return {
          Id: invoice.Id,
          SupplierName: invoice.Supplier?.Name,
          ContractNumber: invoice.Contract?.Number,
          Number: invoice?.Number,
          Amount: invoice?.LimitInTonnes,
          Total: invoice.Contract?.Price,
          Status: this.status[invoice.Status]
        }
      })
    },
  }
}
</script>